var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 8.5V12.5M17.334 6.5V10.5M16.334 1.5C18.7827 1.5 20.1071 1.87476 20.7661 2.16544C20.8539 2.20415 20.8977 2.22351 21.0244 2.34437C21.1003 2.41682 21.2389 2.62939 21.2745 2.72809C21.334 2.89274 21.334 2.98274 21.334 3.16274V13.9111C21.334 14.8199 21.334 15.2743 21.1977 15.5079C21.0591 15.7454 20.9254 15.8559 20.6659 15.9472C20.4108 16.0369 19.896 15.938 18.8662 15.7401C18.1454 15.6017 17.2905 15.5 16.334 15.5C13.334 15.5 10.334 17.5 6.33398 17.5C3.88528 17.5 2.56085 17.1252 1.90187 16.8346C1.81411 16.7958 1.77023 16.7765 1.64358 16.6556C1.56767 16.5832 1.4291 16.3706 1.39345 16.2719C1.33398 16.1073 1.33398 16.0173 1.33398 15.8373L1.33398 5.08885C1.33398 4.18009 1.33398 3.7257 1.47026 3.49214C1.60889 3.25456 1.74258 3.14412 2.00204 3.05281C2.25712 2.96305 2.77202 3.06198 3.80181 3.25985C4.5226 3.39834 5.37746 3.5 6.33398 3.5C9.33398 3.5 12.334 1.5 16.334 1.5ZM13.834 9.5C13.834 10.8807 12.7147 12 11.334 12C9.95327 12 8.83398 10.8807 8.83398 9.5C8.83398 8.11929 9.95327 7 11.334 7C12.7147 7 13.834 8.11929 13.834 9.5Z",
    stroke: "#610D24",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash_icon.f75698de2836cc81ad98c0bd6b0c3cdb.svg";
export { ForwardRef as ReactComponent };